import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { IJoinPolicyModalProps, IPayInfoModalStateProps } from "./index.type";
import { CouponCodeInfo, IUserInfo } from "src/service/types/common.type";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { ProductKey } from "src/config/config";
import { DspProductListType } from "src/mocks/useProductInfo";

// CSR or SSR
const sessionStorage =
  typeof window !== "undefined" ? window.sessionStorage : undefined;

// 새로고침해도 recoil값 유지 해주는 옵션
const { persistAtom } = recoilPersist({
  key: "recoil",
  storage: sessionStorage,
});

// 서비스 정보
export const serviceListAtom = atom({
  key: "serviceList",
  default: [],
});
// Wrapsody eCo 서비스 조회시 사이트 번호
export const serviceNoAtom = atom({
  key: "serviceNo",
  default: 0,
});

// 사이드바 표기 여부
export const isShowSideBarAtom = atom({
  key: "isShowSideBarAtom",
  default: true,
});
export const isShowGuideDownloadModal = atom({
  key: "isShowGuideDownloadModalAtom",
  default: false,
});
// 로그인 여부
export const isAuthAtom = atom({
  key: "isAuth",
  default: false,
  // effects_UNSTABLE: [persistAtom],
});

export const onceLoginUUIDAtom = atom({
  key: "onceLoginUUID",
  default: "",
});
export const dspProductAtom = atom({
  key: "dspProduct",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
export const productKeyAtom = atom<ProductKey | undefined>({
  key: "productKey",
  // default: "",
  default: getProductFromSessionStorage(),
  effects_UNSTABLE: [persistAtom],
});
export const isOpenSelectProductAtom = atom<boolean>({
  key: "isSelectProduct",
  default: false,
});
export const couponCodeAtom = atom<CouponCodeInfo>({
  key: "couponCodeInfoKey",
  // default: "",
  default: undefined,
});
export const userInfoAtom = atom<IUserInfo>({
  key: "userInfo",
  default: {
    companyName: "",
    entryTime: 0,
    loginTime: 0,
    loginType: "",
    menuScope: null,
    status: 0,
    userCode: "",
    userEmail: "",
    userId: "",
    userName: "",
    userType: "",
    loginUnixTime: "",
  },
  effects_UNSTABLE: [persistAtom],
});
// export const payPlanInfoAtom = atom<IPayPlanInfo>({
export const payPlanInfoAtom = atom({
  key: "payPlanInfo",
  default: {},
});
export const isShowPayAtom = atom({
  key: "isShowPay",
  default: false,
});
export const cashStatusAtom = atom({
  key: "cashStatus",
  default: "",
});
export const navStepAtom = atom<number>({
  key: "navStep",
  default: 0,
});
export const hasSiteAtom = atom<boolean | null | string>({
  key: "hasSite",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
export const hasBillAtom = atom<boolean>({
  key: "hasBill",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
export const confirmTrialAtom = atom<boolean>({
  key: "confirmTrial",
  default: false,
});
export const confirmDriveAtom = atom<boolean>({
  key: "confirmDrive",
  default: false,
});
export const confirmBasicAtom = atom<boolean>({
  key: "confirmBasic",
  default: false,
});
export const confirmPlusAtom = atom<boolean>({
  key: "confirmPlus",
  default: false,
});
export const confirmPromotionAtom = atom<boolean>({
  key: "confirmPromotion",
  default: false,
});
export const close30dGuideAtom = atom<boolean>({
  key: "close30dGuide",
  default: false,
});
export const isInitAtom = atom<boolean>({
  key: "isInit",
  default: false,
});
export const typeAtom = atom<string>({
  key: "type",
  default: "",
});

// 모달 관리
// 요금제 관리 모달
export const PayInfoModalStateAtom = atom<IPayInfoModalStateProps>({
  key: "PayInfoModalStateAtom",
  default: {
    priceType: false, // 요금제
    licenseCount: false, // 사용자 수
    payTerm: false, // 결제 주기
    subscriptionsCancel: false, // 정기결제 해지 모달
    subscriptionsActivate: false,

    checkConfirmPrice: false,
    checkConfirmUser: false,
  },
});
export const JoinPolicyModalAtom = atom<IJoinPolicyModalProps>({
  key: "JoinPolicyModalAtom",
  default: {
    showPolicy: false,
    tabTarget: "tab1",
  },
});
export const PasswordInitModalAtom = atom<boolean>({
  key: "PasswordInitModalAtom",
  default: false,
});
// 청구서 모달
export const BillStatementModalAtom = atom<boolean>({
  key: "BillStatementModalAtom",
  default: false,
});
// 구독 재개하기 모달
export const ResumeSubscriptionModalAtom = atom<boolean>({
  key: "ResumeSubscriptionModalAtom",
  default: false,
});

export const showFooterAtom = atom<boolean>({
  key: "showFooterAtom",
  default: false,
});

// my-account 모달
export const showEditNameModalAtom = atom<boolean>({
  key: "showEditNameModalAtom",
  default: false,
});
export const showEditEmailModalAtom = atom<boolean>({
  key: "showEditEmailModalAtom",
  default: false,
});
export const showEditPasswordModalAtom = atom<boolean>({
  key: "showEditPasswordModalAtom",
  default: false,
});
export const showEditMemberModalAtom = atom<boolean>({
  key: "showEditMemberModalAtom",
  default: false,
});
export const showEditDrawalMemberModalAtom = atom<boolean>({
  key: "showEditDrawalMemberModalAtom",
  default: false,
});
